import React, { FC } from 'react'
import { PencilAltIcon, ChevronDoubleLeftIcon } from '@heroicons/react/outline'
import { useRouteMatch, useLocation } from 'react-router-dom'
import useDraft from '../../../redux/draft-drawer/useDraft'
import { StyledDraftDrawerButton } from '.'
import ROUTES from '../../utils/routes'
import useSegment from '../../utils/useSegment'

const DraftDrawerButton: FC = () => {
  const {
    isClear,
    isOpened,
    actions: { openDraft }
  } = useDraft()

  const location = useLocation()
  const { track } = useSegment()
  const { path }: any = useRouteMatch(location.pathname)

  const openDraftDrawer = () => {
    track('Opened Draft Drawer', { button: 'draft-drawer-btn', from: window.location.pathname })
    openDraft()
  }

  const hideDraftButton = () => {
    if (path.includes(ROUTES.affiliates.dashboard)) {
      return true
    }

    if (path.includes(ROUTES.dashboard.community)) {
      return true
    }

    return false
  }

  if (isOpened || hideDraftButton()) {
    return null
  }

  return (
    <StyledDraftDrawerButton id="drawer-fab" isClear={isClear} onClick={() => openDraftDrawer()}>
      {isClear ? <PencilAltIcon /> : <ChevronDoubleLeftIcon />}
      {isClear && 'NEW'}
    </StyledDraftDrawerButton>
  )
}

export default DraftDrawerButton
